import { instance } from '../index';

// 상품 수정
function updateLineitem(id, data) {
  return instance.put(`api/v2/lineitems/${id}`, data);
}

export { updateLineitem };
